import { motion, useAnimation } from 'framer-motion';
import Link from 'next/link';
import styled from 'styled-components';

import { ExclamationMarkSvg } from '../../assets/icons';
import theme from '../../assets/theme';
import { IconWrapper } from './IconWrapper';

const HiringBanner = () => {
  const animation = useAnimation();

  const hoverSequence = async () => {
    await animation.start({ scale: 1.03, transition: { duration: 0.1 } });
    animation.start({ scale: 1, transition: { duration: 0.1 } });
  };
  return (
    <Banner
      animate={animation}
      onHoverStart={hoverSequence}
      onClick={() => {
        window.open(
          'https://curipod.notion.site/The-Curipod-work-Experience-9a732ddf5a904f6abac84d55a733fc02?pvs=4',
          '_blank',
        );
      }}
    >
      <IconWrapper height="30px" width="30px">
        <ExclamationMarkSvg />
      </IconWrapper>
      <p
        style={{
          fontSize: 16,
          marginBottom: 0,
          fontWeight: 'bold',
          color: theme.colors.white,
        }}
      >
        {`P.S We're hiring! `}
        <Link href="">
          <a
            style={{
              fontSize: 16,
              textDecoration: 'underline',
              color: theme.colors.white,
              fontWeight: 'bold',
            }}
          >
            See open positions
          </a>
        </Link>
      </p>
    </Banner>
  );
};

const Banner = styled(motion.div)`
  background-color: ${theme.colors.blue};
  color: ${theme.colors.white};
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  padding: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
`;

export default HiringBanner;
